import type { CurrencyEnum } from "@litres-libs/types";

const currency: { [index: string]: string } = {
  RUB: "₽",
  AZN: "₼",
  BYN: "Br",
  CAD: "$",
  CHF: "₣",
  CNY: "¥",
  CZK: "Kč",
  DKK: "kr",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  KZT: "₸",
  MDL: "L",
  NOK: "NKr",
  PLN: "zł",
  AUD: "$",
  SEK: "kr",
  SGD: "$",
  TRY: "£",
  UAH: "₴",
  USD: "$",
};

export const getCurrencySymbolByCurrencyName = (name: CurrencyEnum): string => {
  return currency[name];
};
